import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Heart, BookOpen, Users, Loader2 } from 'lucide-react';
import { getCatalogue } from '../services/cms';
import { useFavorites } from '../context/FavoritesContext';

const Favorites = () => {
  const { favorites } = useFavorites();
  const [episodes, setEpisodes] = useState(null);

  useEffect(() => { getCatalogue().then(setEpisodes).catch(() => setEpisodes([])); }, []);

  const list = (episodes || []).filter((e) => favorites.includes(e.source_id) || favorites.includes(e.slug));

  return (
    <div className="max-w-7xl mx-auto px-4 py-10 min-h-[60vh]">
      <h1 className="font-display font-700 text-4xl text-foreground mb-2 flex items-center gap-3"><Heart className="w-8 h-8 text-primary fill-primary" /> Mes favoris</h1>
      <p className="text-muted-foreground font-600 mb-10">{list.length} webtoon{list.length > 1 ? 's' : ''} enregistré{list.length > 1 ? 's' : ''}</p>

      {episodes === null ? (
        <div className="py-20 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>
      ) : list.length === 0 ? (
        <div className="text-center py-20">
          <div className="w-20 h-20 rounded-full bg-muted flex items-center justify-center mx-auto mb-5"><Heart className="w-9 h-9 text-muted-foreground" /></div>
          <p className="font-display font-600 text-xl mb-2">Aucun favori pour le moment</p>
          <p className="text-muted-foreground font-600 mb-6">Parcourez le catalogue et ajoutez vos webtoons préférés.</p>
          <Link to="/catalogue" data-testid="favorites-explore-btn" className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary text-white font-800 hover:scale-105 transition-transform shadow-lg shadow-primary/25"><BookOpen className="w-5 h-5" /> Explorer les webtoons</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-5">
          {list.map((e, i) => (
            <Link key={e.source_id} to={`/fiche/${encodeURIComponent(e.slug)}`} data-testid={`favorite-card-${e.slug}`}
              className="card-hover group bg-card rounded-2xl overflow-hidden border border-border">
              <div className="relative aspect-square overflow-hidden">
                {e.featured_image?.url ? <img src={e.featured_image.url} alt={e.titre} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" /> : <div className="w-full h-full bg-muted" />}
              </div>
              <div className="p-3">
                <h3 className="font-display font-600 text-sm leading-snug line-clamp-2 min-h-[36px] group-hover:text-primary transition-colors">{e.titre}</h3>
                {(e.auteurs || []).length > 0 && <p className="text-[11px] text-muted-foreground font-700 mt-1 flex items-center gap-1 truncate"><Users className="w-3 h-3 shrink-0" /> {e.auteurs.map((a) => a.name).join(', ')}</p>}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default Favorites;
